export const VIEW_MODE = {
  FOLDER: 'folder',
  FILE: 'document',
};
